import { useIntl } from '@weenat/wintl';
import { memoize } from 'lodash-es';
import { useCallback } from 'react';
import { useClient } from '../ClientProvider';
import { formatAndConvertValueToNumber, formatValue, formatValueToString } from '../core/formatters';
import { getMyUnit } from '../core/units';
import useQuery from '../useQuery';
const useConvertedValue = () => {
    const intl = useIntl();
    const client = useClient();
    const preferredUnits = useQuery(client.me.getMyProfile()).data?.units;
    const getUnit = useCallback((metric) => getMyUnit(metric, preferredUnits), [preferredUnits]);
    /**
     * Incorrectly named, will only format
     */
    const convertValue = useCallback(({ metric, displayUnit = true, ...options }) => {
        const formatOptions = {
            intl,
            metric,
            unit: getUnit(metric),
            displayUnit,
            ...options
        };
        return formatValue(formatOptions);
    }, [getUnit, intl]);
    /**
     * Will format and convert
     */
    const convertNumberValue = useCallback(({ metric, ...options }) => {
        const formatOptions = {
            intl,
            metric,
            unit: getUnit(metric),
            ...options
        };
        return formatAndConvertValueToNumber(formatOptions);
    }, [getUnit, intl]);
    const formatConvertedValue = useCallback(({ metric, ...options }) => {
        const formatOptions = {
            intl,
            metric,
            unit: getUnit(metric),
            ...options
        };
        return formatValueToString(formatOptions);
    }, [getUnit, intl]);
    const memoizedGetUnit = memoize(getUnit);
    const memoizedConvertValue = memoize(convertValue);
    const memoizedConvertNumberValue = memoize(convertNumberValue);
    const memoizedFormatConvertedValue = memoize(formatConvertedValue);
    return {
        convertValue: memoizedConvertValue,
        convertNumberValue: memoizedConvertNumberValue,
        getUnit: memoizedGetUnit,
        formatConvertedValue: memoizedFormatConvertedValue
    };
};
export default useConvertedValue;
